import { render, staticRenderFns } from "./erpchat.vue?vue&type=template&id=76d7e8ea"
import script from "./erpchat.vue?vue&type=script&lang=js"
export * from "./erpchat.vue?vue&type=script&lang=js"
import style0 from "./erpchat.vue?vue&type=style&index=0&id=76d7e8ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports